import type { GroupProps } from "@mantine/core";
import { Group, Tooltip } from "@mantine/core";
import { Link } from "react-router";
import { MantineCellIcon } from "../MantineCellIcon/MantineCellIcon";
import type { MantineIconCellProps } from "../MantineIconCell";

interface MantineActionLinkCellProps extends MantineIconCellProps {
  to: string;
  tooltip?: string;
  groupProps?: GroupProps;
}

function MantineActionLinkCell({
  IconComponent,
  iconColor,
  renderedCellValue,
  to,
  tooltip,
  groupProps
}: MantineActionLinkCellProps) {
  if (typeof renderedCellValue === "string" && !renderedCellValue) {
    return null;
  }

  return (
    <Group gap="sm" wrap="nowrap" {...groupProps}>
      {renderedCellValue}
      <Tooltip disabled={!tooltip} label={tooltip}>
        <Link to={to}>
          <MantineCellIcon
            iconColor={iconColor}
            IconComponent={IconComponent}
          />
        </Link>
      </Tooltip>
    </Group>
  );
}

export { MantineActionLinkCell };
